jQuery(document).ready(function($) {
    let brandSwiper;
    let sticky_bar_height = 80;
    let linkClicked = false;
    
    const nav = document.querySelector(".brand-search");
    if (!nav) return; // 安全检查

    // --- 1. 动态获取导航栏初始位置 (替代死数值 537) ---
    // 使用函数获取，防止页面加载时图片未加载导致高度计算不准
    const getInitialNavTop = () => {
        return nav.getBoundingClientRect().top + window.scrollY;
    };
    let navTop = getInitialNavTop();

    // 窗口大小改变或图片加载完成后重新校准 navTop
    $(window).on('resize load', () => {
        navTop = getInitialNavTop();
    });

    // --- 2. 初始化 Swiper ---
    const swiperContainer = document.querySelector(".brand-search__chars.swiper");
    if (swiperContainer) {
        brandSwiper = new Swiper(swiperContainer, {
            slidesPerView: "auto",
            spaceBetween: 8,
            freeMode: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    }

    // --- 3. 处理索引点击跳转 ---
    const links = document.querySelectorAll(".brand-search__chars .char-item");
    
    function updateOnClickStickyNavState(links2) {
    links2.forEach((e, index) => {
        const char = e.dataset.char;
        const refElement = document.querySelector(".brand_page [data-char='" + char + "']");

        if (refElement) {
            e.onclick = function(evt) {
                evt.preventDefault();
                linkClicked = true;

                // 1. 立即激活当前点击的字母
                links2.forEach(link => link.classList.remove("active"));
                e.classList.add("active");

                // 2. 实时获取 Header 和 导航栏 的高度
                // 确保类名与你网站一致，例如 .site-header 或 .header-wrapper
                const headerHeight = $(".header-wrapper").outerHeight() || 0; 
                const navHeight = $(nav).outerHeight() || 0;
                
                // 3. 计算总的遮挡高度
                // 桌面端通常是 Header + Nav；移动端如果 Header 随滚动消失，则只计 Nav
                let totalOccupiedHeight;
                if ($("body").width() < 990) {
                    // 如果移动端 Header 也是固定的，请保留 headerHeight
                    totalOccupiedHeight = navHeight + (headerHeight > 0 ? headerHeight : 0);
                } else {
                    totalOccupiedHeight = headerHeight + navHeight;
                }

                // 4. 精准计算终点 (减去总遮挡高度，再加 10-20px 的呼吸感间距)
                const section_top = refElement.getBoundingClientRect().top + window.scrollY - totalOccupiedHeight - 20;

                // 5. 执行滚动
                window.scroll({
                    top: section_top,
                    behavior: "smooth"
                });

                // 6. 同步 Swiper
                if (brandSwiper) brandSwiper.slideTo(index, 300);

                // 7. 锁定 linkClicked 状态直到滚动结束
                setTimeout(() => { linkClicked = false; }, 800);
            };
        }
    });
}
    updateOnClickStickyNavState(links);

    // --- 4. 滚动监控 (处理 Fixed 状态和自动 Active) ---
    window.onscroll = function() {
        const headerHeight = $(".header-wrapper").outerHeight() || 0;
        const triggerPoint = navTop - ( ($("body").width() < 990) ? 0 : headerHeight );

    if (window.scrollY > triggerPoint) {
        nav.classList.add("fixed");
        
    } else {
        nav.classList.remove("fixed");
    }

    // 3. 处理自动 Active 逻辑 (仅在非点击状态下)
    if (!linkClicked) {
        const scrollOffset = ($("body").width() < 990) ? (headerHeight + 100) : (headerHeight + 100);
        const scrollPos_active = window.scrollY + scrollOffset;
        updateStickyNavState(links, scrollPos_active);
    }
};

    function updateStickyNavState(links2, scrollPos_start) {
        let lastIndex = 0;
        links2.forEach((e, index) => {
            const char = e.dataset.char;
            const refElement = document.querySelector(".brand_page [data-char='" + char + "']");

            if (refElement) {
                // 判断逻辑：当前滚动位置超过了品牌区块的顶部
                const section_top = refElement.getBoundingClientRect().top + window.scrollY - 150; 
                if (scrollPos_start >= section_top) {
                    links2.forEach(link => link.classList.remove("active"));
                    e.classList.add("active");
                    lastIndex = index;
                }
            }
        });
        
        if (brandSwiper) brandSwiper.slideTo(lastIndex, 300);
    }

    // --- 5. 搜索功能 (保持防抖) ---
    $(".brand-search__search input").on("input", debounce(() => {
        const searchText = $(".brand-search__search input").val();
        if (searchText) {
            const res = $(".brand__list a:contains('" + searchText + "')");
            $(".brand-search__results").empty();
            if (res.length > 0) {
                res.each((idx, item) => {
                    $(".brand-search__results").append($(item).parent().html());
                });
            }
            $(".brand-search__results").addClass("show");
        } else {
            $(".brand-search__results").removeClass("show");
        }
    }, 300));

    function debounce(fn, delay) {
        let timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, arguments), delay);
        };
    }
});